import { render, staticRenderFns } from "./saleAddonDetailsReport.vue?vue&type=template&id=fa0180de"
import script from "./saleAddonDetailsReport.vue?vue&type=script&lang=js"
export * from "./saleAddonDetailsReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports